var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-tabs",
        {
          model: {
            value: _setup.model,
            callback: function ($$v) {
              _setup.model = $$v
            },
            expression: "model",
          },
        },
        _vm._l(_setup.list, function (item) {
          return _c(
            "v-tab",
            { key: item.key, attrs: { disabled: !item.show } },
            [
              _vm._v(_vm._s(item.name) + " "),
              item.icon
                ? _c("v-icon", { attrs: { right: "", small: "" } }, [
                    _vm._v(_vm._s(item.icon)),
                  ])
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "v-tabs-items",
        {
          staticClass: "py-3 px-2",
          model: {
            value: _setup.model,
            callback: function ($$v) {
              _setup.model = $$v
            },
            expression: "model",
          },
        },
        _vm._l(_setup.list, function (item, index) {
          return _c(
            "v-tab-item",
            { key: item.key, attrs: { disabled: !item.show } },
            [_vm._t("tab-items", null, { tabKey: item.key, index: index })],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }